var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetchDataGetReq, fetchDataPostReq, fetchDataPutReq } from '../apis/apiUtil';
import { convertDataToSelectOptionsBVlocations, dateRangeObj, multiSelectObj } from '../utils/commonUtil';
import { subPrjStatusOptions } from '../models/StatusOptions';
import { multiSelectObjBVlocations } from './projectService';
class SubProjectService {
    getCertUpdateReqStatusComments(data) {
        const url = `getCertUpdateReqStatusComments`;
        return fetchDataPutReq(url, data);
    }
    getSubProjectDetails(data) {
        const url = `getSubProjectDetails`;
        return fetchDataPutReq(url, data);
    }
    getLstRevisedDocs(data) {
        const url = `getLstRevisedDocs`;
        return fetchDataPutReq(url, data);
    }
    getCertProductFamily(data) {
        const url = `getLstProductFamilyForProject`;
        return fetchDataPutReq(url, data);
    }
    getVendorDocComments(data) {
        const url = `getVendorDocComments`;
        return fetchDataPutReq(url, data);
    }
    getPreviousVersionDocs(data) {
        const url = `getPreviousVersionDocs`;
        return fetchDataPutReq(url, data);
    }
    getPrjCountrySpecPrevVerDocs(data) {
        const url = `getPrjCountrySpecPrevVerDocs`;
        return fetchDataPutReq(url, data);
    }
    getComments(data) {
        const url = `getComments`;
        return fetchDataPutReq(url, data);
    }
    saveComment(data) {
        const url = `saveComment`;
        return fetchDataPutReq(url, data);
    }
    saveVendorDocComment(data) {
        const url = `saveVendorDocComment`;
        return fetchDataPostReq(url, data);
    }
    getAllDocument(data) {
        const url = `getAllDocument`;
        return fetchDataPutReq(url, data);
    }
    saveWoVenDocStatus(data) {
        const url = `saveWoVenDocStatus`;
        return fetchDataPostReq(url, data);
    }
    saveWorkOrderVendor(data) {
        const url = `saveWorkOrderVendor`;
        return fetchDataPostReq(url, data);
    }
    getVendorProjectStatus() {
        const url = `getVendorProjectStatus`;
        return fetchDataGetReq(url);
    }
    getVendorClients(data) {
        const url = `getVendorClients`;
        return fetchDataPutReq(url, data);
    }
    getVendorSubProjCountries(data) {
        const url = `getVendorSubProjCountries`;
        return fetchDataPutReq(url, data);
    }
    searchVendorSubProjects(data) {
        const url = `searchVendorSubProjects`;
        return fetchDataPutReq(url, data);
    }
    searchVendorSubProjectsCount(data) {
        const url = `searchVendorSubProjectsCount`;
        return fetchDataPutReq(url, data);
    }
    getVendorSubProjAssignees(data) {
        const url = `getVendorSubProjAssignees`;
        return fetchDataPutReq(url, data);
    }
    getVendorSubProjServiceTypes(data) {
        const url = `getVendorSubProjServiceTypes`;
        return fetchDataPutReq(url, data);
    }
    getVendorSubProjProdSubSeg(data) {
        const url = `getVendorSubProjProdSubSeg`;
        return fetchDataPutReq(url, data);
    }
    getVendorSubProjBussinessUnits(data) {
        const url = `getVendorSubProjBussinessUnits`;
        return fetchDataPutReq(url, data);
    }
    getVendorSubProjTechType(data) {
        const url = `getVendorSubProjTechType`;
        return fetchDataPutReq(url, data);
    }
    getVendorWOStatusByOrder(data) {
        const url = `getVendorWOStatusByOrder`;
        return fetchDataPutReq(url, data);
    }
    getSearchSuggestions(data, url) {
        return __awaiter(this, void 0, void 0, function* () {
            return fetchDataPostReq(url, data);
        });
    }
    getVendorSubPrjFilterSectionData(applicationData, selSubPrjStatus, setSelSubPrjStatus, selEntity, setSelEntity, selLstBVLocation, setSelLstBVLocation, selCountry, setSelCountry, selBvContact, setSelBvContact, selServiceTypeList, setSelServiceTypeList, selProductSubsegmentList, setSelProductSubsegmentList, selLstTechType, setSelLstTechType, selSubProjectAssignedStartDate, setSelSubProjectAssignedStartDate, selVendorStartDate, setSelVendorStartDate, selActualCompletionDate, setSelActualCompletionDate, selVendorPlannedCompletionDate, setSelVendorPlannedCompletionDate, handleClearAllAppliedFilters) {
        return {
            name: 'ven_sub_prj_filter_panel',
            selectOptionsList: this.selectOptionsListSubProject(selSubPrjStatus, setSelSubPrjStatus),
            multiSelectList: [
                multiSelectObj('Entity (Company Name)', selEntity, setSelEntity, applicationData === null || applicationData === void 0 ? void 0 : applicationData.vendorClients),
                multiSelectObj('Country/Territory', selCountry, setSelCountry, applicationData === null || applicationData === void 0 ? void 0 : applicationData.vendorSubPrjCountries),
                multiSelectObj('BV Contact', selBvContact, setSelBvContact, applicationData === null || applicationData === void 0 ? void 0 : applicationData.vendorSubProjAssignees),
                multiSelectObj('Service Type', selServiceTypeList, setSelServiceTypeList, applicationData === null || applicationData === void 0 ? void 0 : applicationData.vendorSubProjServiceTypes),
                multiSelectObj('Technology', selLstTechType, setSelLstTechType, applicationData === null || applicationData === void 0 ? void 0 : applicationData.vendorSubProjTechType),
                multiSelectObj('Product Sub Segment', selProductSubsegmentList, setSelProductSubsegmentList, applicationData === null || applicationData === void 0 ? void 0 : applicationData.vendorSubProjProdSubSeg),
                multiSelectObjBVlocations('BV Location', selLstBVLocation, setSelLstBVLocation, applicationData === null || applicationData === void 0 ? void 0 : applicationData.vendorSubProjBussinessUnits),
            ],
            dateRangeOptions: [
                dateRangeObj('BV Sub Project Assigned Start Date:', selSubProjectAssignedStartDate, setSelSubProjectAssignedStartDate),
                dateRangeObj('Actual Completion Date:', selVendorStartDate, setSelVendorStartDate),
                dateRangeObj('Vendor Start Date:', selActualCompletionDate, setSelActualCompletionDate),
                dateRangeObj('Vendor Planned Completion Date:', selVendorPlannedCompletionDate, setSelVendorPlannedCompletionDate),
            ],
            handleClearAll: handleClearAllAppliedFilters
        };
    }
    selectOptionsListSubProject(selPrjStatus, setSelCertStatus) {
        return [
            {
                selectOptions: {
                    data: subPrjStatusOptions,
                    title: 'Filter By Sub Project Status',
                    value: selPrjStatus,
                    setValue: (val) => setSelCertStatus(val)
                }
            }
        ];
    }
    multiSelectObjBVlocations(title, selList, setSelList, jsonData) {
        return {
            multiSelect: {
                data: convertDataToSelectOptionsBVlocations(jsonData),
                title: title,
                value: selList,
                setValue: setSelList
            }
        };
    }
}
const subProjectService = new SubProjectService();
export default subProjectService;
